import { useEffect, useState } from "react";
import { FeedbackButtonView } from "./FeedbackButtonView";

export function FeedbackButton() {
  const feedbackUrl = process.env.REACT_APP_UX_FEEDBACK_URL;
  const storageKey = "lastFeedbackDate";
  const hideForMonths = 1;

  const [shouldShowButton, setShouldShowButton] = useState(false);

  useEffect(() => {
    if (!feedbackUrl) {
      return;
    }

    const savedDate = localStorage.getItem(storageKey);

    // Если дата не сохранена - показываем кнопку
    if (!savedDate) {
      setShouldShowButton(true);
      return;
    }

    // Проверяем, прошёл ли месяц
    const lastFeedbackDate = new Date(savedDate);
    const nextAvailableDate = new Date(lastFeedbackDate);
    nextAvailableDate.setMonth(nextAvailableDate.getMonth() + hideForMonths);

    setShouldShowButton(new Date() >= nextAvailableDate);
  }, [feedbackUrl]);

  const handleClick = () => {
    localStorage.setItem(storageKey, new Date().toISOString());
    setShouldShowButton(false);
  };

  if (!shouldShowButton) return <></>;

  return <FeedbackButtonView url={feedbackUrl} onClick={handleClick} />;
}
